type TipoCliente = "Maschio" | "Femmina" | "Ditta";
const TipoClienteArray: Array<{ label: TipoCliente; value: string }> = [
  { label: "Maschio", value: "M" },
  { label: "Femmina", value: "F" },
  { label: "Ditta", value: "D" }
];

export {
  TipoCliente,
  TipoClienteArray
};
